
import DrawBase from "./DrawBase"
import EditPoint from "./EditPoint"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawPoint extends DrawBase {
    constructor(options) {
        super(options);
        this._style = undefined;
    }

    get style() {
        return this._style;
    }

    set style(val) {
        this._style = val;
    }

    leftDoubleClick() {

    }

    loadPlot(data) {
        var position = JSON.parse(data.editPositions);
        this.plot = this.createPointbyId(position,data.markId);
        this.plot.point.show = true;
        this.plot.label = {
            show: true,
            text: "注记",
            scale: 1,
            showBackground: false,
            backgroundColor: new Cesium.Color(0.165, 0.165, 0.165, 0.8),
            backgroundPadding: new Cesium.Cartesian2(7, 5),
            pixelOffset: new Cesium.Cartesian2(0, -20),
            fillColor: Cesium.Color.WHITE
        };
        this.plot.extTag = "BH_Feature"; //添加类型标识
        this.plot.extType = "point_Nor"
        this.plot.typeName = "点";
        this.initEditor();
        this.destroy();
        // if(!data.onlyRead){
        //     this.startEdit();
        // }

        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), this.plot, "point")
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr).formLabel, this.plot, "label")

        return this.plot;
    }

    //左键
    leftClick(evt) {
        console.log(this.style);
        var position = this.getCatesian3FromPX(evt.position);
        this.plot = this.createPoint(position);
        this.plot.point.show = true;
        this.plot.label = {
            show: true,
            text: "注记",
            scale: 1,
            showBackground: false,
            backgroundColor: new Cesium.Color(0.165, 0.165, 0.165, 0.8),
            backgroundPadding: new Cesium.Cartesian2(7, 5),
            pixelOffset: new Cesium.Cartesian2(0, -20),
            fillColor: Cesium.Color.WHITE
        };
        // this.plot.billboard = {
        //     show: true,
        //     image: "data/img/marker/mark2.png",
        //     // scale: 1,
        //     pixelOffset: new Cesium.Cartesian2(0, 0),
        //     color: Cesium.Color.WHITE,
        //     rotation: 0,
        //     width: 32,
        //     height: 44
        // }

        this.plot.extTag = "BH_Feature"; //添加类型标识
        this.plot.extType = "point_Nor"
        this.plot.typeName = "点";

        this.initEditor();
        this.entities.push(this.plot);
        this.callback && this.callback(this.plot, this.style);
        this.destroy();
        this.startEdit();
    }

    initEditor() {
        //初始化编辑器
        this.editHelp = new EditPoint(this.options); //初始化编辑类
        this.editHelp.callback = this.callback;
    }
}

export default DrawPoint;